// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--9685d";